import { Grid } from '@material-ui/core';
import Button from 'components/button';
import { Field, Form, Input, Select, Textarea } from 'components/forms';
import { refundForm } from 'components/forms/decorators';
import { gt } from 'components/forms/form/validators';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import createAdvertisingRefundOrderMutation from 'graphql/mutations/orders/create-advertising-refund-order.gql';
import React, { Component } from 'react';

@refundForm(createAdvertisingRefundOrderMutation)
export default class AdvertisingRefundCreate extends Component {
    render() {
        return (
            <Grid container direction="column">
                <SectionBanner />
                <SectionTitle title='Publicidad' />
                <Form
                    fields={[
                        {key: 'estimatedAmount', validators: [gt(0)]},
                        {key: 'type'},
                        {key: 'mediumName'},
                        {key: 'specifications'},
                        {key: 'notes', required: false},
                    ]}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid}) => (
                        <Grid container spacing={2} style={{marginTop: 10}}>
                            <Grid item xs={4}>
                                <Field label='Presupuesto estimado en pesos'>
                                    <Input type='number' {...getFieldProps('estimatedAmount')} />
                                    {renderErrors('estimatedAmount')}
                                </Field>
                            </Grid>
                            <Grid item xs={4}>
                                <Field label='Tipo'>
                                    <Select
                                        options={[
                                            {label: 'Gráfica', value: 'Gráfica'},
                                            {label: 'Radio', value: 'Radio'},
                                            {label: 'TV', value: 'TV'},
                                            {label: 'Otro', value: 'Otro'},
                                        ]}
                                        {...getFieldProps('type')}
                                    />
                                    {renderErrors('type')}
                                </Field>
                            </Grid>
                            <Grid item xs={4}>
                                <Field label='Nombre del medio'>
                                    <Input type='text' {...getFieldProps('mediumName')} />
                                    {renderErrors('mediumName')}
                                </Field>
                            </Grid>
                            <Grid item xs={6}>
                                <Field label='Especificaciones de la pauta'>
                                    <Textarea {...getFieldProps('specifications')} />
                                    {renderErrors('specifications')}
                                </Field>
                            </Grid>
                            <Grid item xs={6}>
                            <Field label='Comentarios para Nidera'>
                                <Textarea {...getFieldProps('notes')} />
                                {renderErrors('notes')}
                            </Field>
                            </Grid>
                            <Grid item xs={12}>
                                {renderErrors('__all__')}
                            </Grid>
                            <Grid item container xs={12} justify='flex-end'>
                                <Grid item xs={3}>
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading} fullWidth>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                    </Form.Actions>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Form>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/advertising/index.js